// Defensive render-side strip for a BARE `orion://…` deep-link that leaked into
// assistant chat text. The assistant is authored to emit universal-links
// (`https://apps.nownia.com/time/…`) or markdown-link targets (`[label](orion://…)`),
// and both of those reach a real screen: `components/Markdown.tsx`'s `a` renderer
// reroutes them through `resolveInAppPath`. But the LLM occasionally hallucinates a
// loose `orion://conversation/<id>/message/<id>` token in plain prose — no
// autolinker matches a non-http(s) scheme, so it renders as ugly inert text. This
// removes such a token before render.
//
// Kept in spirit-identical shape to the native (iOS + Android) agents' strip: a bare
// `orion://` URI with a `](`-negative-lookbehind so a genuine markdown-link target is
// left intact. Only the http(s) universal-link and `](orion://…)` forms are meant to
// survive — this helper never touches an `https://…` URL (esp. `https://maps.google.com/…`).

// `(?<!\]\()` — not the target of a markdown link `[label](orion://…)`.
// The optional whitespace on each side is captured so removing the token doesn't
// leave a doubled space or a space before punctuation: rejoin with a single space
// only when the token sat between two whitespace runs, otherwise close the gap.
const BARE_ORION_URI = /(\s?)(?<!\]\()orion:\/\/\S+(\s?)/g;

export function stripBareDeeplinks(text: string): string {
  if (!text) return text;
  return text.replace(BARE_ORION_URI, (_match, before: string, after: string) =>
    before && after ? ' ' : '',
  );
}
